
import React, { useState } from "react";
import "./PermissionsPage.css";
import Logo from "../../assets/images/Logo.png";
import PermissionsList from "../../components/PermissionList/PermissionList";
import AddPermission from "../../components/AddPermission/AddPermission";
import { addUser } from "../../Services/UserService";
import { User, UserPostModel } from "../../Items/User";


const Header = ({ onOpenUserForm,onSearchChange  }: { onOpenUserForm: () => void, onSearchChange: (value: string) => void }) => (

  <header className="header">
    <section className="logo-section">
      <img src={Logo} alt="Logo" />
    </section>
    <search className="search-wrapper">
      <input 
        type="search" 
        placeholder="חפש משתמש..." 
        onChange={(e) => onSearchChange(e.target.value)} 
      />
        {!document.querySelector<HTMLInputElement>(".search-wrapper input")?.value && (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
    >
      <circle cx="11" cy="11" r="8"></circle>
      <path d="m21 21-4.35-4.35"></path>
    </svg>
  )}
    </search>

    
    <button className="open-user-btn" onClick={onOpenUserForm}>פתח משתמש</button>
    <div className="main-link-permission" style={{ marginRight: "2%" }}>הרשאות</div>
  </header>
);

const PermissionsPage: React.FC = () => {
  const [editingIndex, setEditingIndex] = useState<number | null>(null);
  const [addingNew, setAddingNew] = useState(false);
  const [users, setUsers] = useState<User[]>([]);
  const [searchTerm, setSearchTerm] = useState("");


  const handleAddUser = async (user: UserPostModel) => {
    try {
      const newUser: User = await addUser(user); // שולח ל-backend ומקבל את המשתמש עם id
      setUsers(prev => [...prev, newUser]);      // מוסיף ל-state
      setAddingNew(false);
    } catch (err) {
      console.error("Error adding user", err);
    }
  };


  return (
    <div className="permissions-screen">
      <Header onOpenUserForm={() => setAddingNew(true)} onSearchChange={setSearchTerm}/>
      <div className="list-scroll-container">
      <PermissionsList editingIndex={editingIndex} setEditingIndex={setEditingIndex} searchTerm={searchTerm} />
    </div>
      {addingNew && (
        <div className="user-form-wrapper">
          <AddPermission
            setShowUserForm={() => setAddingNew(false)}
            // onSave={(user: User) => {
            //   UserService.addUser(user)
            //     .then(created => {
            //       console.log("Created user:", created);
            //       setAddingNew(false);
            //     })
            //     .catch(err => console.error(err));
            // }}
            onSave={handleAddUser}
          />
        </div>
      )}
    </div>
  );
};

export default PermissionsPage;
